import {
    ComponentFactoryResolver,
    Injectable,
    Inject,
    ViewContainerRef
} from '@angular/core';
import { GenericConfig, EntityConfig } from '@signature-it/ngx-generic/config';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import * as gadgetsComponents from '@signature-it/ngx-generic/components/gadgets';
import { AuthService } from "@signature-it/ngx-generic/services";
declare let _: any;
declare let $: any;

@Injectable({
    providedIn: 'root'
})
export class DynamicGadgetsService {
    protected factoryResolver: ComponentFactoryResolver;
    protected rootViewContainer: ViewContainerRef;
    protected gadgetsConfig: any;
    currentUserAcl: string[] = [];

    constructor(@Inject(ComponentFactoryResolver) factoryResolver,
                protected authSvc: AuthService) {
        this.factoryResolver = factoryResolver;
    }

    setRootViewContainerRef(viewContainerRef) {
        this.rootViewContainer = viewContainerRef
    }

    addDynamicGadgets($element?) {
        this.gadgetsConfig = EntityConfig.ngxGadgets && EntityConfig.ngxGadgets['gadgets'] ? EntityConfig.ngxGadgets['gadgets'] : GenericConfig.gadgets;
        if (!this.gadgetsConfig || !this.gadgetsConfig.length) return;
        let componentFactory, componentRef, insertedElement, currentConfig;

        this.authSvc.currentUsersData$.subscribe((user: IUser) => {
            if(user) {
                this.currentUserAcl = user.acl.map(x => x['name']);
            }
            let gadgets = this.getAllTagMatches(/^gadget-|^gadget_/i, ($element || document));
            gadgets.forEach((gadget) => {
                currentConfig = this.gadgetsConfig.find(x => x.key.toLowerCase() === gadget.tagName.toLowerCase());
                if (currentConfig && this.hasAcl(currentConfig.acl)) {
                    componentFactory = this.factoryResolver.resolveComponentFactory(gadgetsComponents[currentConfig.type + 'Gadget']);
                    componentRef = componentFactory.create(this.rootViewContainer.injector);
                    componentRef.instance.title = currentConfig.title;
                    componentRef.instance.subTitle = currentConfig.subTitle;
                    componentRef.instance.btnText = currentConfig.btnText;
                    componentRef.instance.btnLink = currentConfig.btnLink;
                    componentRef.instance.colors = currentConfig.colors;
                    componentRef.instance.textColors = currentConfig.textColors;
                    componentRef.instance.key = currentConfig.key;
                    componentRef.instance.title_before = currentConfig.title_before;
                    componentRef.instance.title_after = currentConfig.title_after;
                    componentRef.instance.numOfColForTableViewMobile = currentConfig.numOfColForTableViewMobile || 2;
                    componentRef.instance.dataConfig = currentConfig.data;
                    componentRef.instance.url = currentConfig.url;
                    componentRef.instance.count = currentConfig.count;
                    componentRef.instance.border = currentConfig.border;
                    componentRef.instance.breakLength = currentConfig.breakLength;
                    componentRef.instance.breakLengthMobile = currentConfig.breakLengthMobile;
                    componentRef.instance.attributes = {};
                    componentRef.instance.solrAttributes = {};

                    for(let i = 0; i < gadget.attributes.length; i++){
                        let attribute = gadget.attributes.item(i);
                        if (attribute['nodeName'].match(/^solr_/)) {
                            componentRef.instance.solrAttributes[attribute['nodeName'].replace(/^solr_/, '')] = attribute['nodeValue'];
                        } else {
                            componentRef.instance.attributes[attribute['nodeName']] = attribute['nodeValue'];
                        }
                    }
                    Object.keys(currentConfig).forEach((conf) => {
                        if (conf.match(/^solr_/)) {
                            componentRef.instance.solrAttributes[conf.replace(/^solr_/, '')] = currentConfig[conf];
                        }
                    });
                    insertedElement = this.rootViewContainer.insert(componentRef.hostView);
                    gadget.replaceWith($(insertedElement)[0].rootNodes[0]);
                }
            })
        });


    }

    getAllTagMatches(regEx, element) {
        return Array.prototype.slice.call(element.querySelectorAll('*')).filter(function (el) {
            return el.tagName.match(regEx);
        });
    }

    hasAcl(requiredAcl): boolean {
        if (!requiredAcl) return true;
        return requiredAcl.every(v => this.currentUserAcl.includes(v));
    }
}
